import { parseContact } from "@/components/si/ResumeContact";

const norm = (v) => (typeof v === "string" ? { value: v, source: "resume" } : v);
const kindOf = (url) => (/linkedin\.com/i.test(url) ? "linkedin" : /github\.com/i.test(url) ? "github" : /(twitter|x)\.com\//i.test(url) ? "x" : "portfolio");

// Profile from GET /talent/{id} -> editable contact lists; anything missing is read from the resume text.
export const contactOf = (p) => {
  const parsed = parseContact(p?.contact_edited_at ? "" : p?.resume?.text || "");
  const emails = (p?.emails?.length ? p.emails : parsed.emails).map(norm);
  const phones = (p?.phones?.length ? p.phones : parsed.phones).map(norm);
  const base = p?.links?.length ? p.links : parsed.links;
  const links = base.map((l) => (typeof l === "string" ? { url: l, kind: kindOf(l), source: "resume" } : { source: "resume", kind: kindOf(l.url), ...l }));
  if (p?.linkedin_url && !links.some((l) => l.url.includes("linkedin.com"))) links.unshift({ url: p.linkedin_url, kind: "linkedin", source: "resume" });
  return {
    full_name: p?.full_name || "", current_title: p?.current_title || "", current_employer: p?.current_employer || "",
    location: p?.location || parsed.location || "", emails, phones, links,
  };
};

export const linkFrom = (raw) => { const url = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`; return { url, kind: kindOf(url), source: "manual" }; };
export const LINK_LABEL = { linkedin: "LinkedIn", github: "GitHub", x: "X / Twitter", portfolio: "Website" };
